import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {Link} from "react-router-dom";
import {useAllUsersQuery} from "../../../../types.d";
import {useState} from "react";
import {UsersSelectList} from "../../../partials/UsersSelectList";
import {normalizeShortRole} from "../../../../utils/normalizeShortRole";
import {DashboardContent} from "../../index/DashboardContent";
import {container} from "@intelingu/core/IoC/container";
import {WorkspaceStore} from "../../../../stores/WorkspaceStore";

export const PreviewDashboardRoute = (props: RouteComponentProps<{ role: string }>) => {
    const workspace = container.get(WorkspaceStore);
    const user = workspace.user;

    const role = props.match.params.role.toUpperCase();
    const users = useAllUsersQuery();
    const [selectedUser, setSelectedUser] = useState<number>(null);

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item"><Link to="/dashboards">Roles & Dashboards</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Dashboard
                    </li>
                </ol>
            </nav>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                View stats for user:
                <div style={{ width: 400 }} className={'mb-5 mt-1'}>
                    <UsersSelectList
                        onSelect={setSelectedUser}
                        roles={[normalizeShortRole(role)]} />
                </div>

                <DashboardContent role={role} userId={selectedUser} />

                <Link
                    to={`/creation/next/${selectedUser || workspace.courseId}/${role}`}
                    className={'btn btn-outline-primary btn-lg'}
                >
                    Let me create something great
                </Link>
            </div>
        </div>
    </div>
};
